import { InjectionToken } from '@angular/core';

export const LANDING_PAGE_URL = new InjectionToken<string>('LANDING_PAGE_URL');
